
const Footer = () => {
    return (
        <footer className="text-center md:text-right p-6 text-sm">
            <span>© {new Date().getFullYear()} Copyright. </span>
            <a className="" href="https://tailwind-elements.com/">JHB IT Institute</a>
        </footer>
    )
}

export default Footer